import styled from 'styled-components'

export const MapContainer = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`

export const LoadingContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: grid;
	place-items: center;
	z-index: 100;
	pointer-events: none;
`

export const ErrorContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 16px;

	svg {
		flex-shrink: 0;
	}
`
